import { render, staticRenderFns } from "./NewsPhone.vue?vue&type=template&id=3da7e3e4&scoped=true"
import script from "./NewsPhone.vue?vue&type=script&lang=js"
export * from "./NewsPhone.vue?vue&type=script&lang=js"
import style1 from "./NewsPhone.vue?vue&type=style&index=1&id=3da7e3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da7e3e4",
  null
  
)

export default component.exports